import { EDiscoverItemLayoutOptions } from 'constants/graphqlTypes';

const noPaddingsLayouts = [EDiscoverItemLayoutOptions.FullBleed, EDiscoverItemLayoutOptions.Immersive];

export const REF_PLACEHOLDER = '00000000-0000-0000-0000-000000000000';
export const DELETED_USER = '@deleted-user';
export const hasPaddings = (layout: EDiscoverItemLayoutOptions): boolean => !noPaddingsLayouts.includes(layout);

export const getEveryoneTime = (): string => Math.floor(Date.now() / 1000).toString();
